<div class="row d-flex flex-grow-1 align-content-start sortable"
     [ngClass]="{'editing': isEditing, 'empty': columnIsEmpty, 'h-100': isEditing}"
     [nxtSortablejs]="undefined"
     [config]="sortableOptions"
     (init)="handleSortableJsInit()">
    <ng-content></ng-content>
</div>
